import React from 'react'
import Table from './table'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'

const COMPONENT_GROUP = 'member_search';

class EventAwardTable extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventAwardTable', options)
        }
    }

    options = {
        export: false
    }

    componentDidMount() {
        this.props.onRef(this)
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    columns = [
        { field: 'award_id' },
        { field: 'event_id' },
        { field: 'typeDisplay' },
        { field: 'money', type: 'currency' },
        { field: 'balance_before', type: 'currency' },
        { field: 'balance_after', type: 'currency' },
        { field: 'total_bet', type: 'currency' },
        { field: 'bet_record_id' },
        { field: 'created_at', type: 'datetime' },
        { field: 'updated_at', type: 'datetime' },
    ]

    SetData(data) {
        this.table.SetData(data, this.props.currency)
    }

    queryData = (queryParams) => {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            `${API.PALYER_EVENT_AWARD_LIST}/${queryParams.pf_account}`,
            queryParams,
            (data) => {
                const awardsList = data['awards']
                awardsList.forEach((elem, idx) => (awardsList[idx]['typeDisplay'] = this.t(`Event.${elem['type']}`)))

                this.table.SetData(awardsList, this.props.currency)
            },
            (_err) => {
                this.table.SetData([])
            }
        )
    }

    render() {
        return <Table ownerName="EventAwardTable" columns={this.columns} onRef={(ref) => (this.table = ref)} options={{export: this.options.export}} />
    }
}

const styles = (_theme) => {
    return {}
}

EventAwardTable.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    dataService: PropTypes.object,
    currency: PropTypes.string,
}

export default hoc(styles)(EventAwardTable)
